<script lang="ts">

    import FormPlaca from "./validate/FormPlaca.svelte";
    import {IDataVehicle} from "../data";
    import LinearProgress from "@smui/linear-progress";
    import {getFormatter} from "../utils";
    import {Cart} from "../models/cart";
    import {createEventDispatcher, onMount} from "svelte";
    import ListCart from "./cart/ListCart.svelte";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../naui/atoms/NauiButton.svelte";
    import DispatchSection from "./checkout/dispatch/DispatchSection.svelte";
    import DispatchServiceSection from "./checkout/dispatch/DispatchServiceSection.svelte";
    import Snackbar, {Label} from "@smui/snackbar";
    import IconButton from "@smui/icon-button";
    import {ManagerVehicles} from "../models/manager-vehicles";

    const dispatch = createEventDispatcher()

    let confirmed = false;
    let notAvailable: any;
    let formatter = getFormatter();
    let dialog = {
        open: false,
        message: ''
    };
    let snackbar = {
        cmpt: undefined,
        message: ''
    }

    export let loading = false;
    export let params;
    export let vehicle: IDataVehicle;
    export let cart: Cart;


    onMount(() => {
        const manager = ManagerVehicles.getInstance();
        manager.selected$.subscribe((next) => {
            vehicle = next
        });
    });


    async function queryByPlaca(params) {
        vehicle = null;
        loading = true;
        try {
            const {query} = params;
            const url = new URL('/backend/servicio/datos-vehiculo/', window.origin);
            url.search = new URLSearchParams(query).toString()
            const response = await fetch(url.toString(), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.ok) {
                const data = await response.json();
                setVehicle(data);
            } else {
                throw new Error();
            }
        } catch (e) {
            dialog = {
                open: true,
                message: `<p>Se ha presentado un error consultando el vehiculo</p>`
            }
        }
        loading = false;
    }

    function setVehicle(_) {
        vehicle = _;
    }

    async function confirm() {
        loading = true;
        try {
            const body = await cart.updateVehicle(vehicle);
            const manager = ManagerVehicles.getInstance();
            manager.addVehicle(vehicle);
            loading = false;
            notAvailable = body;
            if (notAvailable) {
                dialog = {
                    open: true,
                    message: `<p>Algunos productos no están disponibles o no son compatibles</p>`
                }
            }
            confirmed = true;
        } catch (e) {
            dialog = {
                open: true,
                message: `<p>Se ha presentado un error confirmando el vehiculo</p>`
            }
            loading = false;
        }
    }

    function next() {
        dispatch('next')
    }

    function cancel() {
        confirmed = false;
        vehicle = null;
    }

    function closeDialog() {
        dialog = {
            open: false,
            message: ''
        };
    }
</script>
{#if confirmed}
    <ListCart {cart}/>
    {#if notAvailable}
        <hr>
        <section class="not-available">
            <div class="max-w-900px mx-auto">
                <h2 class="block my-ii">Productos no disponibles</h2>
                <div style="filter: grayscale(100%);">
                    <DispatchSection title="Productos de envío a domicilio"
                                     items={notAvailable.parts}/>
                    <DispatchSection title="Accesorios"
                                     items={notAvailable.accessories}/>
                    <DispatchSection title="Servicios"
                                     items={notAvailable.services}/>
                    <DispatchServiceSection title="Mantenimiento preventivo"
                                            items={notAvailable.revisions}/>
                    <DispatchServiceSection title="Planes"
                                            items={notAvailable.plans}/>
                </div>
            </div>
        </section>
        <hr>
    {/if}
    <div class=" pt-ii pb-1 border-bottom">
        <div class="box-b">
            <strong>Subtotal de tu compra</strong>
            <h3>{formatter(cart.subtotal)}</h3>
        </div>
    </div>
    <div class="box my-15">
        <a on:click={()=>cancel()} class="underlined">Asignar otro vehiculo</a>
    </div>
    <div class="box my-15">
        <div class="btn accent min-w-200px text-c"
             on:click={()=>next()}>
            Continuar
        </div>
    </div>
{:else}

    {#if vehicle}
        {#if !loading}
            <div class="bg-gray p-1 mb-1">
                {#if vehicle.placa}
                    <b class="mb-ii">Placa</b>
                    <p>{vehicle.placa}</p>
                {/if}
                <b class="mb-ii">Modelo</b>
                <p>{vehicle.descModeloTASA}</p>
                <p>{vehicle.descModelo}</p>
            </div>
            <div class="box-b sx-ii">
                <button class="btn min-w-200px text-c disabled"
                        on:click={()=>vehicle=null}>
                    ASIGNAR OTRO VEHICULO
                </button>
                <button class="btn accent min-w-200px text-c"
                        on:click={()=>confirm()}>
                    CONFIRMAR VEHICULO
                </button>
            </div>
        {:else}
            <div class="text-c loading-bar">
                <LinearProgress class="w-100" indeterminate/>
                <small>Confirmando Vehiculo...</small>
            </div>
        {/if}
    {:else}
        <FormPlaca {params}
                   {loading}
                   enableByVehicle={false}
                   title="Selecciona tu método de confirmación"
                   showCancel={false}
                   on:validateVehicle={({detail})=>queryByPlaca(detail)}
                   on:vehicle={({detail})=>setVehicle(detail)}/>
    {/if}
{/if}

<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {@html dialog.message}
    </Content>
    <Actions>
        <div class="box sx-ii">
            <NauiButton caption="ACEPTAR"
                        color="accent"
                        mode="solid"
                        on:click={()=>closeDialog()}/>
        </div>
    </Actions>
</Dialog>

<Snackbar bind:this={snackbar.cmpt}>
    <Label>{snackbar.message}</Label>
    <Actions>
        <IconButton class="material-icons" title="Dismiss" on:click={()=>snackbar.cmpt.close()}>close</IconButton>
    </Actions>
</Snackbar>